import { createInMemoryAtom, dedupe } from '@exodus/atoms'

const createFiatAssetsAtom = () =>
  dedupe(
    createInMemoryAtom({
      defaultValue: undefined,
    })
  )

const fiatAssetsAtomDefinition = {
  id: 'fiatAssetsAtom',
  type: 'atom',
  factory: createFiatAssetsAtom,
  public: true,
}

export default fiatAssetsAtomDefinition
